import React from "react";
import styles from "./Header.module.scss";

const Header = () => {
  return (
    <div className={styles.hero}>
      <h1>Love to work from Home? Search jobs around the world</h1>
    </div>
  );
};

export default Header;
